'use strict';

const TimePresenter = require('../presenters/time');

const BaseView = require('./base');

class TimeView extends BaseView {
  tagName() {
    return 'li';
  }

  initialize() {
    this.presenter = TimePresenter;
    this.templateName = 'time';
    this.setModule('glive_booking_redesign');
  }

  events() {
    return { click: 'select' };
  }

  select(args, kill = false) {
    if (!kill) {
      $(args.toElement).trigger('click', true);
      this.trigger('select', this.model);
    }
  }
}

module.exports = TimeView;
